import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { hqTyps } from '../../utils/eis-statics-data';
import SalesManageStaticsTeamRow from './SalesManageStaticsTeamRow';
//----------------------------------------------------------------
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});
//----------------------------------------------------------------
const SalesManageStaticsTeamTable = ({
  loading,
  selectedYear,
  selectedCompany,
  data,
  tableRef,
  headerRows,
}) => {
  const classes = useStyles();

  if (!headerRows || !data) {
    return null;
  }

  return (
    <Paper sx={{ maxWidth: '80vw' }}>
      <TableContainer sx={{ overflow: 'auto' }}>
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                회사
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                {selectedYear}년 예산
              </TableCell>
              {headerRows &&
                headerRows.map((header) => {
                  return (
                    <TableCell key={header?.id} align="center" colSpan={3}>
                      {header?.label}
                    </TableCell>
                  );
                })}
            </TableRow>
            <TableRow>
              {headerRows.map((header) => {
                return hqTyps.map((typ, index) => (
                  <TableCell align="center" key={typ.id}>
                    {typ.name}
                  </TableCell>
                ));
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {!data || data?.length === 0 ? (
              <TableRow>
                <TableCell align="center" colSpan={43}>
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <SalesManageStaticsTeamRow data={data} headerRows={headerRows} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SalesManageStaticsTeamTable;
